<template>
	<div
		id="discourse_schedule"
		:class="'panel schedule ' +
			(isHeaderIndent? ' mt-0 pt-0 ' : '') +
			(isFooterIndent? ' mb-0 pb-0 ' : '') +
			block.appearance"
	>
		<div class="container">
			<div
				:class="[
					'row',
				]"
			>
			<div class="col-12 col-lg-6">
				<div class="schedule_block">
					<h2 class="title title-lg">
						{{ block.block_title }}
					</h2>
					<ul class="schedule_list">
						<li v-for="(item, index) in block.content.partners" :key="index">
							<div v-if="'theme' in item && item.theme !==null" class="description">
								{{ item.theme }}
							</div>
							<div v-if="'title' in item && item.title !==null" class="title">
								{{ item.title }}
							</div>
							<div
								v-if="'description' in item && item.description !==null"
								class="description"
								v-html="item.description"
							/>
						</li>
					</ul>
				</div>
			</div>
				<div class="col-12 col-lg-6 order-lg-1">
					<div class="image_block">
						<b-img-lazy :src="block.content.image.src" alt />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'PanelDiscourseTalkThemes',
	mixins: [panel],
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/schedule-short";
</style>
